import { api } from '../api';
import type { FeatureFlags } from '../../types/api';

export const SystemAPI = {
  saveOduNames: (req: unknown) =>
    api.post('/api/media/names', req, { idempotent: true }),
  getOduNames: (req: unknown) =>
    api.post('/api/media/names/get', req),

  getFeatureFlags: () => api.get<FeatureFlags>('/api/admin/feature-flags'),
  saveFeatureFlags: (flags: FeatureFlags) =>
    api.put<FeatureFlags>('/api/admin/feature-flags', flags, { idempotent: true }),
};
